import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';

export const createDirectionTorchAtlas = (size: number): string => {
  const res = createCanvas(size, size, 2);

  if (!res || !res.ctx) {
    return '';
  }

  const { ctx } = res;

  const cx = size / 2;
  const cy = size / 2;
  const radius = size / 2;

  const gradient = ctx.createRadialGradient(cx, cy, 0, cx, cy, radius);

  gradient.addColorStop(0, 'rgba(255, 255, 255, 1.0)');
  gradient.addColorStop(0.4, 'rgba(255, 255, 255, 0.85)');
  gradient.addColorStop(1, 'rgba(255, 255, 255, 0.0)');

  const angle = Math.PI / 3;
  const startAngle = -Math.PI / 2 - angle / 2;
  const endAngle = -Math.PI / 2 + angle / 2;

  ctx.fillStyle = gradient;
  ctx.beginPath();
  ctx.moveTo(cx, cy);
  ctx.arc(cx, cy, radius, startAngle, endAngle);
  ctx.closePath();
  ctx.fill();

  return res.canvas.toDataURL();
};
